export enum USER_TYPES {
  GERENTE = 'gerente',
  PILOTO = 'vendedor',
  SUPERVISOR = 'supervisor',
  JEFE = 'jefe',
  AGENCIA = 'agencia',
  ESCUDERIA = 'escuderia',
  SUPER_ADMIN = 'super_admin'
}

export interface User {
  uid: string
  authenticated: boolean | null
  avatar: string
  name: string
  escuderia: string
  agencia: string
  escuderiaName: string | null
  agenciaName: string | null
  zona: string | null
  email: string
  cargo: string | null
  totalUsers: number | null
  tags: string[]
  userType: USER_TYPES
  points: number
  unconfirmed_email: string
  celular: string
  numero_de_documento: string
  update_file: boolean
  total_points: number
}
